<app-search-result-card>
  <backstage-color-bg-icon
    class="align-self-start mb-3"
    color="blue"
    iconName="route"
    ngbTooltip="Course"
  >
  </backstage-color-bg-icon>
  <app-ellipsis class="mb-2" [lines]="3">
    <a
      class="h5 text-decoration-none text-lightblue-700 mb-2"
      [appSearchResultLink]="result"
      [href]="result.url">{{ result.title }}</a>
  </app-ellipsis>
  <app-ellipsis [lines]="4">
    <div class="small text-gray-600">{{ result.synopsis }}</div>
  </app-ellipsis>
</app-search-result-card>
